import { createAction, props } from "@ngrx/store";
import { ArrayInterface } from "../../../models/arrayInterface";

export enum CcxArrayActionTypes {
  set = "[ccxArray Object] set Array"
}

export const setCcxArrayObject = createAction(CcxArrayActionTypes.set, props<{ ccxArrayObject: { [prop: string]: ArrayInterface } }>());
